import React, { memo } from 'react';
import classnames from 'classnames';
import "./index.scss";
const SelectList = ({
  data,
  maxSelect = 1,
  value = [],
  onChange
}) => {
  const onClick = React.useCallback(e => {
    e?.stopPropagation?.();
    const {
      selected,
      value: targetValue
    } = e.target.dataset;
    const change = (nextList, selected) => {
      if (maxSelect === 1) {
        onChange(nextList.length ? nextList.slice(-1) : [targetValue], targetValue, selected);
      } else {
        onChange(nextList.slice(0, maxSelect), targetValue, selected);
      }
    };
    if (selected === 'true') {
      change(value.filter(v => !!v && v !== targetValue), false);
    } else {
      change([...value, targetValue], true);
    }
  }, [value, onChange, maxSelect]);
  return /*#__PURE__*/React.createElement("ul", {
    className: "cc-select-list"
  }, data.map(({
    label,
    value: itemValue
  }) => {
    const selected = value.includes(itemValue);
    return /*#__PURE__*/React.createElement("li", {
      className: classnames('cc-select-list-item', {
        selected
      }),
      key: itemValue,
      "data-value": itemValue,
      "data-selected": selected,
      onClick: onClick
    }, label, /*#__PURE__*/React.createElement("span", {
      className: "iconfont icon-gouxuan"
    }));
  }));
};
SelectList.displayName = 'cc-select-list';
export default /*#__PURE__*/memo(SelectList);